import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { NgxLoggerService } from '@go-modules/services/logger/logger.service';
import type { LtiLmsNameMappings } from '@lti/app/types';
import { ERROR_RENDERERS } from '@lti/app/types';
import { AppDataService } from '@go-modules/services/app-data/app-data.service';
import { ActiveBrandService } from '@go-modules/services/active-brand';
import { Subject, tap } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-error',
	templateUrl: './app-error.component.html',
	styleUrls: ['./app-error.component.scss'],
	standalone: false
})
export class AppErrorComponent implements OnInit, OnDestroy {
	private destroy$ = new Subject<void>();

	public errors: any;
	public lmsName: string;
	public mappings: LtiLmsNameMappings;

	public errorRenderer: string;
	public hasTitle: boolean;

	constructor (
		private logger: NgxLoggerService,
		private elementRef: ElementRef,
		public appDataService: AppDataService,
		private activeBrandService: ActiveBrandService
	) {
		this.hasTitle = true;
	}

	public get translationParams () {
		return this.activeBrandService.getTranslationParams();
	}

	public ngOnInit () {
		this.appDataService.appData$.pipe(
			tap((appData) => this.initErrorState(appData)),
			takeUntil(this.destroy$)
		).subscribe();
	}

	public ngOnDestroy () {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private initErrorState (appData): void {
		this.errors = appData.errors;
		this.lmsName = appData.lmsName;
		this.mappings = appData.lmsNameMappings;

		if (this.errors == null) {
			this.errorRenderer = ERROR_RENDERERS.DEFAULT;
		} else if (this.errors.toolUnavailable) {
			this.errorRenderer = ERROR_RENDERERS.TOOL_UNAVAILABLE;
		} else if (this.errors.requiredParameters) {
			this.errorRenderer = ERROR_RENDERERS.PARAMETER;
		} else if (this.errors.activityNotFound) {
			this.errorRenderer = ERROR_RENDERERS.ACTIVITY_NOT_FOUND;
		} else if (this.errors.invalidActivityTypeChange) {
			this.errorRenderer = ERROR_RENDERERS.INVALID_ACTIVITY_TYPE_CHANGE;
		} else if (this.errors.courseLicenseExpired) {
			this.errorRenderer = ERROR_RENDERERS.COURSE_LICENSE_EXPIRED;
		} else if (this.errors.missingLti1p3Deployment) {
			this.errorRenderer = ERROR_RENDERERS.MISSING_DEPLOYMENT;
		} else if (this.errors.deprecatedLaunch) {
			this.errorRenderer = ERROR_RENDERERS.DEPRECATED_LAUNCH;
		} else {
			this.errorRenderer = ERROR_RENDERERS.DEFAULT;
		}

		this.hasTitle = this.errors != null &&
			!this.errors.duplicateApp &&
			!this.errors.toolUnavailable &&
			!this.errors.courseLicenseExpired &&
			!this.errors.deprecatedLaunch &&
			(this.errorRenderer !== ERROR_RENDERERS.DEFAULT);

		this.elementRef.nativeElement.classList.add(this.errorRenderer);

		this.logger.error(this.errors || 'Unknown error during bootstrap');
	}
}
